import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { PublicLayoutComponent } from './layout/public-layout/public-layout/public-layout.component'

export const newRoutes: Routes = [
  {
    path: '',
    children: [
      {
        component: PublicLayoutComponent,
        path: '',
        loadChildren: () => import('./features/public/public.module').then((m) => m.PublicModule)
      }
    ]
  },
  { path: '**', redirectTo: '' }
]

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(newRoutes, {
      initialNavigation: 'enabledBlocking',
      anchorScrolling: 'enabled',
      onSameUrlNavigation: 'reload'
    })
  ],
  exports: [RouterModule]
})
export class ClosedRoutingModule {}
